import { DT } from '../core/constants';

export interface Loop {
  stop(): void;
}

const STEP_MS = DT * 1000;
const MAX_FRAME_MS = 250; // clamp to avoid a spiral of death after a stall

/**
 * Fixed-timestep game loop. `onTick` runs at a constant DT (decoupled from the
 * display refresh rate); `onRender` runs once per animation frame. This keeps
 * the simulation deterministic regardless of FPS.
 */
export function startLoop(onTick: () => void, onRender: () => void): Loop {
  let acc = 0;
  let last = performance.now();
  let raf = 0;
  let running = true;

  const frame = (now: number): void => {
    if (!running) return;
    acc += Math.min(now - last, MAX_FRAME_MS);
    last = now;
    while (acc >= STEP_MS) {
      onTick();
      acc -= STEP_MS;
    }
    onRender();
    raf = requestAnimationFrame(frame);
  };

  raf = requestAnimationFrame(frame);
  return {
    stop() {
      running = false;
      cancelAnimationFrame(raf);
    },
  };
}
